import { ActionTree, Commit, GetterTree, MutationTree } from 'vuex'
import stationApi from '../../api/station'

export interface RootState {
    version: string;
}

export class stationType {
    value: number | undefined;
    text: string | undefined;
    sellingProduct: string | undefined;
    buyingProduct: string | undefined;
}
const state = Array<stationType>();
const getters: GetterTree<Array<stationType>, RootState> = {
    stationType(state: Array<stationType>) {
        return state
    }
};
export const mutations: MutationTree<Array<stationType>> = {
    LOAD_STATIONTYPES(state: Array<stationType>, stationTypes: Array<stationType>) {
        state.length=0;
        stationTypes.forEach(element => {
            state.push(element)
        });
    },
    CLEAR_STATIONTYPES(state: Array<stationType>) {
        state.length = 0
    }
};
const actions: ActionTree<Array<stationType>, RootState> = {
    async getStationTypes({ state, commit }: { commit: Commit, state: Array<stationType> }): Promise<Array<stationType>> {
        commit('CLEAR_STATIONTYPES')
        if (state && state.length > 0) return state;
        try {
            const response = await stationApi.getStationTypes()
            if (response && response.data && response.data.resultType === 200) {
                const data = response.data.payload.map((e: { name: string; id: number; buyingProduct: string, sellingProduct: string }) =>
                    ({ text: e.name, value: e.id, buyingProduct: e.buyingProduct, sellingProduct: e.sellingProduct }))
                commit('LOAD_STATIONTYPES', data)
                return state;
            }
            else {
                commit('CLEAR_STATIONTYPES')
                return state;
            }
        }
        catch (error) {
            commit('CLEAR_STATIONTYPES')
            return state;
        }
    }
}
export default {
    state,
    getters,
    mutations,
    actions
}